import React, { useState } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/module/faq.css";

export default function FAQs() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const faqData = [
    {
      question: "What range of IT services do you provide?",
      answer:
        "Our expertise spans a comprehensive suite of IT solutions — from custom software and mobile/web app development to cloud computing, API integration, UI/UX design, and strategic IT consulting tailored to your business needs.",
    },
    {
      question:
        "Do you develop mobile apps for both Android and iOS platforms?",
      answer:
        "Absolutely! We craft high-performance, cross-platform apps using cutting-edge frameworks like React Native and Flutter, as well as bespoke native applications designed specifically for Android or iOS ecosystems.",
    },
    {
      question:
        "Can your solutions integrate seamlessly with our existing systems?",
      answer:
        "Yes, integration is our specialty. We engineer robust API connections and automate workflows to ensure your new systems work harmoniously with your current technology stack, boosting efficiency and productivity.",
    },
    {
      question: "How do you prioritize data security within your solutions?",
      answer:
        "Security is at the core of our development process. We implement advanced encryption methods, secure coding standards, multi-factor authentication, and full compliance with global data privacy regulations like GDPR to protect your critical data.",
    },
    {
      question: "Do you offer ongoing support after project completion?",
      answer:
        "Definitely. We provide continuous support including system maintenance, proactive monitoring, performance optimization, and feature enhancements to ensure your solution evolves smoothly with your business.",
    },
    {
      question:
        "How do you manage project timelines and ensure timely delivery?",
      answer:
        "Our agile methodology ensures flexibility and transparency throughout the project. We break down the development into clear milestones, provide regular progress updates, and work diligently to deliver on schedule without compromising quality.",
    },
    {
      question: "Can your team assist with UI/UX design for my application?",
      answer:
        "Absolutely! Our talented in-house designers specialize in creating engaging, user-centric interfaces that reflect your brand identity, prioritize usability, and adapt seamlessly across devices.",
    },
    {
      question: "How do you approach reporting and data analytics?",
      answer:
        "We build tailored dashboards and analytics tools that empower you to monitor key performance indicators, understand user behavior, and make informed data-driven decisions in real time.",
    },
  ];

  return (
    <div className="section section__faq">
      <div className="container faq">
        <h5 className="drop-from-top">FAQ</h5>
        <div className="title drop-from-top">
          <h2 style={{ marginBottom: "30px" }}>
            What do clients typically want to know before starting a project
            with us?
          </h2>
        </div>

        <div className="group faq">
          {/* Left Column */}
          <div className="left">
            {faqData.slice(0, 4).map((item, index) => {
              const isActive = activeIndex === index;
              return (
                <div className="faq-element slide-from-left" key={index}>
                  <p
                    className={`question ${isActive ? "active" : ""}`}
                    onClick={() => toggleAnswer(index)}
                    style={{ cursor: "pointer" }}
                  >
                    {item.question}
                  </p>
                  <p
                    className="answer"
                    style={isActive ? { maxHeight: "90px" } : {}}
                  >
                    {item.answer}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Right Column */}
          <div className="right">
            {faqData.slice(4).map((item, index) => {
              const currentIndex = index + 4;
              const isActive = activeIndex === currentIndex;
              return (
                <div className="faq-element slide-from-right" key={currentIndex}>
                  <p
                    className={`question ${isActive ? "active" : ""}`}
                    onClick={() => toggleAnswer(currentIndex)}
                    style={{ cursor: "pointer" }}
                  >
                    {item.question}
                  </p>
                  <p
                    className="answer"
                    style={isActive ? { maxHeight: "90px" } : {}}
                  >
                    {item.answer}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
